import { selector } from 'recoil';
import {
  completedComponentIdsState,
  recentlyItemCompleted,
  ScenarioItem,
  scenarioState,
} from './scenarioState';
import { skippedScenarioItemsState } from './skippedScenarioItemsState';
import { pageState } from './pageState';

export const displayedScenarioItemState = selector<ScenarioItem[]>({
  key: 'displayedScenarioItem',
  get({get}) {
    const scenario = get(scenarioState);
    const page = get(pageState);
    if (page.location === 'preview') {
      return scenario.items;
    }

    const completedComponentIds = get(completedComponentIdsState);
    const skippedItemIds = get(skippedScenarioItemsState).map(i => i.id);
    const items = [];
    for (const item of scenario.items) {
      if (skippedItemIds.includes(item.id)) {
        continue;
      }
      if (item.components.every(c => completedComponentIds.includes(c.id))) {
        items.push(item);
        continue;
      }
      if (!get(recentlyItemCompleted)) {
        items.push(item);
      }
      return items;
    }
    return items;
  },
});

export const currentScenarioItemState = selector({
  key: 'currentScenarioItem',
  get({get}) {
    const displayed = get(displayedScenarioItemState);
    return displayed[displayed.length - 1];
  },
});
